function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Dropdown = /*#__PURE__*/ function() {
    "use strict";
    function Dropdown() {
        _class_call_check(this, Dropdown);
        _define_property(this, "classes", {
            optionActive: 'list__item_active',
            result: 'dropdown__values',
            opened: 'dropdown_show'
        });
        _define_property(this, "attributes", {
            value: '[data-dropdown-value]',
            label: '[data-dropdown-label]',
            option: '[data-dropdown-id]'
        });
    }
    _create_class(Dropdown, [
        {
            key: "handleClose",
            value: function handleClose($dropdown) {
                $dropdown.classList.remove(this.classes.opened);
            }
        },
        {
            key: "handleOpen",
            value: function handleOpen($dropdown) {
                if (!$dropdown.classList.contains(this.classes.opened) && document.querySelector(".".concat(this.classes.opened))) {
                    this.handleClose(document.querySelector(".".concat(this.classes.opened)));
                }
                if (!$dropdown.classList.contains(this.classes.opened)) {
                    $dropdown.classList.add(this.classes.opened);
                } else {
                    this.handleClose($dropdown);
                }
            }
        },
        {
            key: "handleSelect",
            value: function handleSelect($dropdown) {
                var _this = this;
                var $items = $dropdown.querySelectorAll(this.attributes.option);
                $items.forEach(function($item) {
                    $item.addEventListener('click', function() {
                        var $label = $dropdown.querySelector(_this.attributes.label);
                        var $input = $dropdown.querySelector(_this.attributes.value);
                        if ($dropdown.dataset.dropdown === 'radio') {
                            if (!$item.classList.contains(_this.classes.optionActive)) {
                                var value = $item.dataset.dropdownId;
                                var text = $item.innerHTML;
                                var $active = $dropdown.querySelector(".".concat(_this.classes.optionActive));
                                if ($active) $active.classList.remove(_this.classes.optionActive);
                                $item.classList.add(_this.classes.optionActive);
                                $input.value = value;
                                if ($label) $label.innerHTML = text;
                                _this.handleClose($dropdown);
                                $input.dispatchEvent(new CustomEvent('input'));
                                window.dispatchEvent(new CustomEvent('dropdownChange'));
                            }
                        }
                        if ($dropdown.dataset.dropdown === 'checkbox') {
                            var labelArray = [];
                            var valueArray = [];
                            $item.classList.toggle(_this.classes.optionActive);
                            $items.forEach(function($option) {
                                if ($option.classList.contains(_this.classes.optionActive)) {
                                    valueArray.push($option.dataset.dropdownId);
                                    labelArray.push($option.innerText);
                                }
                            });
                            if ($label) {
                                $label.innerHTML = labelArray.length ? labelArray.join(', ') : null;
                            }
                            $input.value = valueArray.length ? valueArray.join(';') : '';
                            $label.style.removeProperty('color');
                            $input.dispatchEvent(new CustomEvent('input'));
                            window.dispatchEvent(new CustomEvent('dropdownChange'));
                        }
                        if ($input.value === '' && $label.dataset.dropdownLabel !== '') $label.innerHTML = $label.dataset.dropdownLabel;
                    });
                });
            }
        },
        {
            key: "handleHide",
            value: function handleHide() {
                var _this = this;
                var dropdownHide = function() {
                    var dropdownOpened = document.querySelector(".".concat(_this.classes.opened));
                    if (dropdownOpened) {
                        _this.handleClose(dropdownOpened);
                    }
                };
                document.addEventListener('click', function(event) {
                    var $el = event.target;
                    if (!$el.matches('.dropdown') && !$el.closest('.dropdown')) {
                        dropdownHide();
                    }
                });
                document.addEventListener('scroll', dropdownHide);
                window.addEventListener('resize', dropdownHide);
            }
        },
        {
            key: "handleApply",
            value: function handleApply() {
                var _this = this;
                document.querySelectorAll('[data-dropdown]').forEach(function($dropdown) {
                    if ($dropdown.dataset.dropdownInit === undefined) {
                        $dropdown.querySelector("".concat(_this.attributes.label)).addEventListener('click', function() {
                            _this.handleOpen($dropdown);
                        });
                        _this.handleSelect($dropdown);
                        $dropdown.setAttribute('data-dropdown-init', 'true');
                    }
                });
            }
        },
        {
            key: "init",
            value: function init() {
                this.handleHide();
                this.handleApply();
            }
        }
    ]);
    return Dropdown;
}();
export default Dropdown;
